import Loadable from '../../components/loadable';

const ManageEmailMfaChannel = Loadable({
  loader: () => import('../../components/mfa/manage_email_mfa_channel'),
  type: 'modal',
});

angular.module('shared').value('ManageEmailMfaChannel', ManageEmailMfaChannel);
